import React, { useEffect, useState } from "react";
import { FaCheck, FaClock } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Badge, Card, Col, Form, Row, Table } from "react-bootstrap";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import AddNewStudyUnblindEmergencyRequest from "./AddNewStudyUnblindEmergencyRequest";
import StudyUnblindEmergencyRequestActivities from "./StudyUnblindEmergencyRequestActivities";
import { eiwrsUnblindingEmergencyRequestServices } from "../../../../APIServices/EIWRS/UnblindManagement/eiwrsUnblindingEmergencyRequestServices";
import ViewStudyEmergencyRequestDetail from "./ViewStudyEmergencyRequestDetail";
import Moment from "react-moment";
import UpdateStatusStudyUnblindEmergencyRequest from "./UpdateStatusStudyUnblindEmergencyRequest";

const StudyUnblindEmergencyRequestDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [unblindData, setUnblindData] = useState("");
  const [statsRequestData, setStatsRequestData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [requestList, setRequestList] = useState([]);
  const [unblindEmergencyRequestCount, setUnblindEmergencyRequestCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [unblindId, setUnblindId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [unblindEmergencyRequestActivity, setUnblindEmergencyRequestActivity] = useState([]);
  const [unblindEmergencyRequestActivityCount, setUnblindEmergencyRequestActivityCount] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(unblindEmergencyRequestCount / itemsPerPage);

  const getEIWRSUnblindingEmergencyRequestData = async (e) => {
    setLoading(true);
    let data = await eiwrsUnblindingEmergencyRequestServices.getEIWRSUnblindingEmergencyRequestData(
      studyId,
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setRequestList(data?.data || []);
    setUnblindEmergencyRequestCount(data?.count || 0);
    setLoading(false);
  };

  const getEIWRSUnblindingEmergencyRequestStats = async (e) => {
    let data = await eiwrsUnblindingEmergencyRequestServices.getEIWRSUnblindingEmergencyRequestStats(
      studyId,
      StudyMode,
    );
    setStatsRequestData(data?.data || []);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSUnblindingEmergencyRequest",
      studyId,
      unblindData?.unblindId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setUnblindEmergencyRequestActivity(data?.data || []);
    setUnblindEmergencyRequestActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [unblindData]);

  useEffect(() => {
    getEIWRSUnblindingEmergencyRequestData();
  }, [searchData, pageNumber, itemsPerPage]);

  useEffect(() => {
    getEIWRSUnblindingEmergencyRequestStats();
  }, []);

  const StatusBadge = ({ status }) => {
    let className = "bg-secondary";
    let dotColor = "#6c757d";

    if (status === "approved") {
      className = "bg-success";
      dotColor = "#198754";
    } else if (status === "pending") {
      className = "bg-warning";
      dotColor = "#daa206";
    } else if (status === "revoked") {
      className = "bg-danger";
      dotColor = "#dc3545";
    }

    return (
      <Badge
        className={`${className} text-capitalize hstack gap-1`}
        style={{ width: "fit-content" }}
      >
        <span
          className="d-inline-block rounded-circle"
          style={{ backgroundColor: dotColor }}
        ></span>
        {status}
      </Badge>
    );
  };

  const overviewCards = [
    {
      title: "Total",
      value: statsRequestData?.total,
      subtitle: "Total requests received in the study",
      icon: <FaCheck className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Pending",
      value: statsRequestData?.pending,
      subtitle: "Requests awaiting review and decision",
      icon: <FaClock className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Approved",
      value: statsRequestData?.approved,
      subtitle: "Requests successfully approved",
      icon: <FaCheck className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Revoked",
      value: statsRequestData?.revoked,
      subtitle: "Previously approved requests revoked",
      icon: <FaXmark className="bg-white text-danger shadow-sm" />,
    },
  ];

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {(StudyMode === "DBP Mode" || eiwrsPermission?.liveManageEmergencyUnblinding || eiwrsPermission?.qcManageEmergencyUnblinding) &&
            <>
              <i
                title={isFormOpen ? "Close Form" : "Add New"}
                onClick={() => {
                  setIsFormOpen(!isFormOpen);
                  setUnblindId("");
                }}
                className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
                  }`}
              />
              <div className="vr"></div>
            </>
          }
          {unblindEmergencyRequestCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={unblindId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyUnblindEmergencyRequest getEIWRSUnblindingEmergencyRequestStats={getEIWRSUnblindingEmergencyRequestStats} getEIWRSUnblindingEmergencyRequestData={getEIWRSUnblindingEmergencyRequestData} />
          )}
          <>
            <div className="p-2 border-bottom" style={{ backgroundColor: "#f8f9fa" }}>
              <Row className="g-2 py-2">
                {overviewCards?.map((item, index) => (
                  <Col xl={3} lg={4} md={6} sm={12} key={index}>
                    <Card className="app-card bg-light border h-100">
                      <Card.Body>
                        <div className="d-flex gap-3">
                          <div className="study_icopn">
                            {item.icon}
                          </div>

                          <div>
                            <Card.Title style={{ fontSize: 16 }}>
                              {item.title}
                            </Card.Title>

                            <Card.Text className="m-0">
                              {item.value || "0"}
                            </Card.Text>

                            <Card.Text style={{ fontSize: 11 }}>
                              {item.subtitle}
                            </Card.Text>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
            {loading ? (
              <PageLoader />
            ) : unblindEmergencyRequestCount === 0 ? (
              <NoDataFoundTable MSG={"Study Unblind Request not found!"} />
            ) : requestList?.length === 0 ? (
              <NoDataFoundTable MSG={"Search Study Unblind Request not found!"} />
            ) : (
              <>
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Sr.
                      </th>
                      <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 1)}>
                        UnblindId
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>
                        Site
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 3)}>
                        Subject
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>
                        Unblinded By
                      </th>
                      <th style={{ width: 80 }} onMouseDown={(e) => onMouseDown(e, 5)}>
                        Status
                      </th>
                      <th style={{ width: 120 }} onMouseDown={(e) => onMouseDown(e, 6)}>
                        Unblind DT
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 7)}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestList?.map((unblindData, index) => (
                      <tr
                        key={index}
                        title="View Details CP"
                        className={`${unblindId === unblindData?._id ? "highlighted" : ""
                          }`}
                        onClick={() => setIsFormOpen(false)}
                      >
                        <td
                          onClick={() => {
                            setUnblindData(unblindData);
                            setUnblindId(unblindData?._id);
                          }}
                          className="text-center"
                        >
                          {index + 1 + startIndex}.
                        </td>
                        <td
                          onClick={() => {
                            setUnblindData(unblindData);
                            setUnblindId(unblindData?._id);
                          }}
                        >
                          {unblindData?.unblindNumber}
                        </td>
                        <td
                          onClick={() => {
                            setUnblindData(unblindData);
                            setUnblindId(unblindData?._id);
                          }}
                        >
                          {unblindData?.siteName}
                        </td>
                        <td
                          onClick={() => {
                            setUnblindData(unblindData);
                            setUnblindId(unblindData?._id);
                          }}
                        >
                          {unblindData?.subjectName}
                        </td>
                        <td
                          onClick={() => {
                            setUnblindData(unblindData);
                            setUnblindId(unblindData?._id);
                          }}
                        >
                          {unblindData?.unblindByName}
                        </td>
                        <td
                          onClick={() => {
                            setUnblindData(unblindData);
                            setUnblindId(unblindData?._id);
                          }}
                        >
                          <StatusBadge status={unblindData.status} />
                        </td>
                        <td
                          onClick={() => {
                            setUnblindData(unblindData);
                            setUnblindId(unblindData?._id);
                          }}
                        >
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {unblindData?.createdAt}
                          </Moment>
                        </td>
                        <td>
                          <button
                            onClick={(e) => {
                              setUnblindData(unblindData);
                              setToggle2();
                              e.stopPropagation();
                            }}
                            className="updateProfile mx-2"
                            style={{ padding: "1px 10px" }}
                          >
                            View
                          </button>
                          {(StudyMode === "DBP Mode" || eiwrsPermission?.liveManageEmergencyUnblinding || eiwrsPermission?.qcManageEmergencyUnblinding) &&
                            <>
                              {unblindData.status === "pending" &&
                                <button
                                  onClick={(e) => {
                                    setUnblindData(unblindData);
                                    setToggle3();
                                    e.stopPropagation();
                                  }}
                                  className="updateProfile mx-2"
                                  style={{ padding: "1px 10px" }}
                                >
                                  Approved Now
                                </button>
                              }
                              {unblindData.status === "approved" &&
                                <button
                                  onClick={(e) => {
                                    setUnblindData(unblindData);
                                    setToggle1();
                                    e.stopPropagation();
                                  }}
                                  className="removeProfile mx-2"
                                  style={{ padding: "1px 10px" }}
                                >
                                  Revoke
                                </button>
                              }
                            </>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="position-sticky bottom-0 start-0">
                  <Pagination
                    totalPage={totalPage}
                    pageNumber={pageNumber}
                    itemsPerPage={itemsPerPage}
                    totalItems={unblindEmergencyRequestCount}
                    setPageNumber={setPageNumber}
                    setItemsPerPage={setItemsPerPage}
                  />
                </div>
              </>
            )}
          </>
        </SplitPane>
        {unblindId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setUnblindId("")}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyUnblindEmergencyRequestActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                unblindEmergencyRequestActivity={unblindEmergencyRequestActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                unblindData={unblindData}
                unblindEmergencyRequestActivityCount={unblindEmergencyRequestActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <ViewStudyEmergencyRequestDetail
        Show={!toggle2}
        Hide={setToggle2}
        unblindData={unblindData}
        Title={"View Unblind Details"}
      />
      <UpdateStatusStudyUnblindEmergencyRequest
        Show={!toggle1}
        Hide={setToggle1}
        unblindData={unblindData}
        setUnblindId={setUnblindId}
        getEIWRSUnblindingEmergencyRequestStats={getEIWRSUnblindingEmergencyRequestStats}
        getEIWRSUnblindingEmergencyRequestData={getEIWRSUnblindingEmergencyRequestData}
        Title={"Revoke now"}
        status="revoked"
      />
      <UpdateStatusStudyUnblindEmergencyRequest
        Show={!toggle3}
        Hide={setToggle3}
        unblindData={unblindData}
        setUnblindId={setUnblindId}
        getEIWRSUnblindingEmergencyRequestStats={getEIWRSUnblindingEmergencyRequestStats}
        getEIWRSUnblindingEmergencyRequestData={getEIWRSUnblindingEmergencyRequestData}
        Title={"Approve Now"}
        status="approved"
      />
    </>
  );
};

export default StudyUnblindEmergencyRequestDataList;
